import { useEffect, useState } from "react";

import TableContainer from "../Tables/TableContainer";
import DatePicker from "../../components/DatePicker";

import { tableHeaders } from "../../hooks/constants";
import {
  load_service_grouped_quotes,
  update_quote_status,
} from "../../actions/agenda_content";
import { usePatientNavigation } from "../../hooks/useDetailNavigation";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";

const PatientFinances = ({ patientId }) => {
  const dispatch = useDispatch();
  const nowDate = new Date();
  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });

  const [selectedAction, setSelectedAction] = useState("updatePagado");
  const [checkedServices, setCheckedServices] = useState([]);
  const [serviceGroupedList, setServiceGroupedList] = useState([]);
  const [finantialSummary, setFinantialSummary] = useState({
    pagado: 0,
    pendiente: 0,
    total_esperado: 0,
    total_citas: 0,
    asistencias: 0,
    canceladas: 0,
  });
  const { goToPatientServiceQuotes } = usePatientNavigation();

  const fetchServiceGroupedtList = async () => {
    const { year, month } = dateValues;
    dispatch(checkAuthenticated());

    const data = await load_service_grouped_quotes({
      year,
      month,
      patient: patientId,
    });
    if (data) {
      setServiceGroupedList(data);
      const f_summary = {
        pagado: 0,
        pendiente: 0,
        total_esperado: 0,
        total_citas: 0,
        asistencias: 0,
        canceladas: 0,
      };
      data.forEach((item) => {
        f_summary.pagado += item.payed;
        f_summary.pendiente += item.pending;
        f_summary.total_esperado += item.price;
        f_summary.total_citas += item.citas;
        f_summary.asistencias += item.assistance_confirmed;
        f_summary.canceladas += item.suspended;
      });
      setFinantialSummary(f_summary);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedAction(event.target.value);
  };
  const handleUpdateCheckedServices = async (checkedList, updateValue) => {
    if (checkedList.length === 0) {
      setCheckedServices([]);
      return;
    }
    const stringList = checkedList.join(",");
    const filterData = {
      patients: patientId,
      services: stringList,
      ...dateValues,
    };
    const bodyData = {
      status_payment: updateValue,
    };
    await update_quote_status(filterData, bodyData).then(
      fetchServiceGroupedtList()
    );
  };

  const handleCheckedAction = (services) => {
    switch (selectedAction) {
      case "updatePagado":
        handleUpdateCheckedServices(services, "pagado");
        break;
      case "updatePendiente":
        handleUpdateCheckedServices(services, "pendiente");
        break;
      default:
        console.log("No action selected or recognized");
    }
  };
  const tableConfig = {
    headers: tableHeaders.patientQuotesTable,
    checkable: true,
    detailFunction: goToPatientServiceQuotes,
    listData: serviceGroupedList,
    servicesPatientId: patientId,
    tableHeight: "table-height-5",
    checkedList: checkedServices,
    setCheckedList: setCheckedServices,
  };

  useEffect(() => {
    fetchServiceGroupedtList();
  }, [dateValues]);
  return (
    <div className="grouped-quote-list">
      <div className="d-flex align-items-center gap-2 mb-2">
        <h3 className="mb-0">Total de Citas y Servicios</h3>
        <DatePicker dateValues={dateValues} setDateValues={setDateValues} />
      </div>
      <div className="d-flex flex-wrap justify-content-evenly gap-2">
        <div className="flex-fill">
          <TableContainer tableConfig={tableConfig} />
          <div className="quotes-table-footer d-flex justify-content-end my-2">
            <div className="d-flex table-options gap-2">
              <Form.Select
                aria-label="Default select example"
                onChange={handleSelectChange}
                value={selectedAction}
              >
                <option value="updatePagado">Marcar Como Pagado</option>
                <option value="updatePendiente">Marcar Como Pendiente</option>
              </Form.Select>
              <Button
                variant="primary d-flex align-items-center gap-2"
                onClick={(e) => handleCheckedAction(checkedServices)}
              >
                Confirmar Accion
              </Button>
            </div>
          </div>
        </div>
        <div className="patient-breakdown d-flex flex-column">
          <h4>Desglose Financiero</h4>
          <div className="d-flex d-xxl-block flex-wrap justify-content-evenly flex-fill gap-3">
            <div className="patient-breakdown-types mb-2">
              <h5 className="breakdown-type">Mensual</h5>

              <div className="breakdown-list d-flex flex-wrap gap-2">
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Pagado</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">
                      ${finantialSummary.pagado}
                    </p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">
                      {finantialSummary.total_esperado === 0
                        ? "0"
                        : (
                            (finantialSummary.pagado /
                              finantialSummary.total_esperado) *
                            100
                          ).toFixed(1)}
                      %
                    </p>
                  </div>
                </div>
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Pendiente</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">
                      ${finantialSummary.pendiente}
                    </p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">
                      {finantialSummary.total_esperado === 0
                        ? "0"
                        : (
                            (finantialSummary.pendiente /
                              finantialSummary.total_esperado) *
                            100
                          ).toFixed(1)}
                      %
                    </p>
                  </div>
                </div>
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Total Esperado</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">
                      ${finantialSummary.total_esperado}
                    </p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">100%</p>
                  </div>
                </div>
              </div>
              <div className="row mt-3 w-100">
                <div className="col-sm-12 col-md-4 d-flex flex-column align-items-center">
                  <span>Total</span>
                  <h3>{finantialSummary.total_citas}</h3>
                </div>
                <div className="col-sm-6 col-md-4 d-flex flex-column align-items-center">
                  <span>Asistencias</span>
                  <h3>{finantialSummary.asistencias}</h3>
                </div>
                <div className="col-sm-6 col-md-4 d-flex flex-column align-items-center">
                  <span>Canceladas</span>
                  <h3>{finantialSummary.canceladas}</h3>
                </div>
              </div>
            </div>
            {/* <div className="patient-breakdown-types mb-2">
              <h5 className="breakdown-type">Anual</h5>
              <div className="breakdown-list d-flex flex-wrap gap-2">
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Pagado</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">$100.000</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">75%</p>
                  </div>
                </div>
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Pendiente</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">$100.000</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">75%</p>
                  </div>
                </div>
                <div className="breakdown-item">
                  <div className="breakdown-item-title">
                    <p className="fs-5 fw-bold m-0">Total Esperado</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-4 fw-bold m-0">$100.000</p>
                  </div>
                  <div className="breakdown-item-value">
                    <p className="fs-5 m-0">75%</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientFinances;
